(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["allies"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  class AlliesCarousel {
    constructor(section) {
      this.section    = section;
      this.sectionId  = section.dataset.sectionId;
      this.dataEl     = section.querySelector('#allies-data-' + this.sectionId);

      if (!this.dataEl) return;

      try {
        this.allies = JSON.parse(this.dataEl.textContent);
      } catch {
        return;
      }

      this.total    = this.allies.length;
      this.current  = 0;

      this.slides   = Array.from(section.querySelectorAll('.allies-section__slide'));
      this.nameEl   = section.querySelector('[data-allies-name]');
      this.ctaEl    = section.querySelector('[data-allies-cta]');
      this.prevBtn  = section.querySelector('[data-allies-prev]');
      this.nextBtn  = section.querySelector('[data-allies-next]');

      if (this.total === 0 || this.slides.length === 0) return;

      this._init();
      if (this.total > 1) this._bindEvents();
    }

    _init() {
      this._updatePositions();
    }

    _bindEvents() {
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => this._navigate(-1));
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => this._navigate(1));
      }

      /* Swipe support */
      let touchStartX = 0;
      this.section.addEventListener('touchstart', (e) => {
        touchStartX = e.changedTouches[0].clientX;
      }, { passive: true });
      this.section.addEventListener('touchend', (e) => {
        const delta = e.changedTouches[0].clientX - touchStartX;
        if (Math.abs(delta) > 40) this._navigate(delta < 0 ? 1 : -1);
      }, { passive: true });

      /* Click on a side card to navigate to it */
      this.slides.forEach((slide) => {
        slide.addEventListener('click', () => {
          const pos = parseInt(slide.dataset.pos, 10);
          if (pos === -1) this._navigate(-1);
          else if (pos === 1) this._navigate(1);
        });
      });
    }

    _navigate(direction) {
      if (this.total <= 1) return;
      this.current = (this.current + direction + this.total) % this.total;
      this._animateName();
      this._updatePositions();
      this._updateCta();
    }

    _updatePositions() {
      this.slides.forEach((slide) => {
        const index = parseInt(slide.dataset.index, 10);
        const offset = ((index - this.current + this.total) % this.total);
        /* Map offset → visual position (-3…+3, null = fully hidden) */
        let pos;
        if (offset === 0)                    pos = 0;
        else if (offset === 1)               pos = 1;
        else if (offset === this.total - 1)  pos = -1;
        else if (offset === 2)               pos = 2;
        else if (offset === this.total - 2)  pos = -2;
        else if (offset === 3)               pos = 3;
        else if (offset === this.total - 3)  pos = -3;
        else                                 pos = null;

        if (pos !== null) {
          slide.dataset.pos = pos;
        } else {
          delete slide.dataset.pos;
        }
      });
    }

    _animateName() {
      if (!this.nameEl) return;
      this.nameEl.classList.add('is-transitioning');
      setTimeout(() => {
        const ally = this.allies[this.current];
        if (ally) this.nameEl.textContent = ally.company_name || '';
        this.nameEl.classList.remove('is-transitioning');
      }, 130);
    }

    _updateCta() {
      if (!this.ctaEl) return;
      const ally = this.allies[this.current];
      if (ally && ally.url) {
        this.ctaEl.href = ally.url;
      }
    }
  }

  function init() {
    document.querySelectorAll('.allies-section[data-section-id]').forEach((section) => {
      if (!section.__alliesCarousel) {
        section.__alliesCarousel = new AlliesCarousel(section);
      }
    });
  }

  /* Theme editor live reloading */
  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target.querySelector('.allies-section[data-section-id]');
    if (section) section.__alliesCarousel = new AlliesCarousel(section);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["editorial-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function optimizeEditorialHeaderVideos() {
      var videos = document.querySelectorAll('.editorial-header__video');
      var isDesktop = window.innerWidth >= 750;

      videos.forEach(function (video) {
        if (video.tagName !== 'VIDEO') return;

        if (isDesktop) {
          if (video.getAttribute('preload') !== 'auto') {
            video.setAttribute('preload', 'auto');
            if (video.readyState === 0) video.load();
          }
        } else {
          video.setAttribute('preload', 'none');
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', optimizeEditorialHeaderVideos);
    } else {
      optimizeEditorialHeaderVideos();
    }

    var resizeTimeout;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(optimizeEditorialHeaderVideos, 250);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  // Optimize video loading: Only load videos on desktop (>=750px)
  // This prevents the 6MB video from loading on mobile, saving bandwidth
  (function() {
    function optimizeHeroVideos() {
      const videos = document.querySelectorAll('.hero__video');
      const isDesktop = window.innerWidth >= 750;
      
      videos.forEach(video => {
        if (isDesktop) {
          // On desktop: enable video loading
          video.setAttribute('preload', 'auto');
          // If video hasn't loaded yet, trigger load
          if (video.readyState === 0) {
            video.load();
          }
        } else {
          // On mobile: prevent video loading completely
          video.setAttribute('preload', 'none');
          // Remove src attributes to prevent any loading
          const sources = video.querySelectorAll('source');
          sources.forEach(source => {
            const src = source.getAttribute('src');
            if (src) {
              source.setAttribute('data-src', src);
              source.removeAttribute('src');
            }
          });
        }
      });
    }

    // Run on page load
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', optimizeHeroVideos);
    } else {
      optimizeHeroVideos();
    }

    // Re-check on resize (debounced)
    let resizeTimeout;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(optimizeHeroVideos, 250);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lead-magnet"] && !Shopify.designMode) return;
  try {
    
  class LeadMagnetForm extends HTMLElement {
    connectedCallback() {
      if (this.dataset.bound === 'true') return;
      this.dataset.bound = 'true';

      this.form = this.querySelector('form');
      if (!this.form) return;

      this.isSubmitting = false;
      this.sourceLabel = this.dataset.source || '';
      this.successDefault = this.dataset.successMessage || '';
      this.klaviyoCompanyId = this.dataset.klaviyoCompanyId || '';
      this.klaviyoLeadMagnetListId = this.dataset.klaviyoLeadMagnetListId || '';
      this.klaviyoNewsletterListId = this.dataset.klaviyoNewsletterListId || '';
      this.tagsInput = this.form.querySelector('[data-lead-magnet-tags]');
      this.newsletterCheckbox = this.form.querySelector('[data-lead-magnet-newsletter]');
      this.emailInput = this.form.querySelector('[data-lead-magnet-email]');
      this.submitButton = this.form.querySelector('[data-lead-magnet-submit]');
      this.errorEl = this.form.querySelector('[data-lead-magnet-error]');
      this.successEl = this.form.querySelector('[data-lead-magnet-success]');
      this.successTextEl = this.form.querySelector('[data-lead-magnet-success-text]');

      // Block every native submit path (Enter key, browser quirks, etc.)
      this.form.setAttribute('novalidate', 'novalidate');
      this.form.addEventListener('submit', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.handleSubmit();
      });

      if (this.submitButton) {
        this.submitButton.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.handleSubmit();
        });
      }

      if (this.emailInput) {
        this.emailInput.addEventListener('keydown', (event) => {
          if (event.key === 'Enter') {
            event.preventDefault();
            this.handleSubmit();
          }
        });
      }
    }

    isNewsletterOptIn() {
      return !!(this.newsletterCheckbox && this.newsletterCheckbox.checked);
    }

    setTags() {
      if (!this.tagsInput) return;
      const baseTags = (this.tagsInput.getAttribute('data-lead-magnet-base-tags') || 'lead-magnet')
        .split(',')
        .map((tag) => tag.trim())
        .filter(Boolean);
      const newsletterTag = (this.tagsInput.getAttribute('data-newsletter-tag') || 'newsletter').trim();
      const tags = this.isNewsletterOptIn() && newsletterTag
        ? Array.from(new Set([...baseTags, newsletterTag]))
        : baseTags;
      this.tagsInput.value = tags.join(',');
    }

    trackKlaviyo() {
      const email = this.emailInput ? this.emailInput.value.trim() : '';
      if (!email) return;

      const newsletterOptIn = this.isNewsletterOptIn();
      const profile = {
        $email: email,
        email: email,
        Source: this.sourceLabel,
        'Signup Date': new Date().toISOString(),
        'Lead Magnet Opt-In': true,
        'Newsletter Opt-In': newsletterOptIn
      };

      if (newsletterOptIn) {
        profile.$source = `${this.sourceLabel} + Newsletter`;
      }

      if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
        window.klaviyo.identify(profile);
        window.klaviyo.track('Lead Magnet Signup', {
          Email: email,
          Source: this.sourceLabel,
          'Signup Type': 'Lead Magnet',
          'Newsletter Opt-In': newsletterOptIn,
          Timestamp: new Date().toISOString()
        });
        if (newsletterOptIn) {
          window.klaviyo.track('Newsletter Opt-In', {
            Email: email,
            Source: this.sourceLabel,
            Timestamp: new Date().toISOString()
          });
        }
        return;
      }

      if (typeof window._learnq === 'undefined') return;
      window._learnq.push(['identify', profile]);
      window._learnq.push(['track', 'Lead Magnet Signup', {
        Email: email,
        Source: this.sourceLabel,
        'Signup Type': 'Lead Magnet',
        'Newsletter Opt-In': newsletterOptIn,
        Timestamp: new Date().toISOString()
      }]);
      if (newsletterOptIn) {
        window._learnq.push(['track', 'Newsletter Opt-In', {
          Email: email,
          Source: this.sourceLabel,
          Timestamp: new Date().toISOString()
        }]);
      }
    }

    // Subscribe to a Klaviyo list via Client Subscriptions API.
    async subscribeToKlaviyoList(email, listId, customSource, extraProperties = {}) {
      if (!email || !this.klaviyoCompanyId || !listId) {
        return false;
      }

      const payload = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: customSource || this.sourceLabel,
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  properties: extraProperties,
                  subscriptions: {
                    email: {
                      marketing: {
                        consent: 'SUBSCRIBED'
                      }
                    }
                  }
                }
              }
            }
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: listId
              }
            }
          }
        }
      };

      const response = await fetch(
        `https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(this.klaviyoCompanyId)}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            revision: '2025-01-15'
          },
          body: JSON.stringify(payload)
        }
      );

      if (!response.ok) {
        console.error('Klaviyo subscribe failed', listId, response.status);
        return false;
      }

      return true;
    }

    async subscribeToLeadMagnetList(email) {
      return this.subscribeToKlaviyoList(email, this.klaviyoLeadMagnetListId, this.sourceLabel, {
        Source: this.sourceLabel,
        'Lead Magnet Opt-In': true,
        'Newsletter Opt-In': this.isNewsletterOptIn()
      });
    }

    async subscribeToNewsletterList(email) {
      return this.subscribeToKlaviyoList(
        email,
        this.klaviyoNewsletterListId,
        `${this.sourceLabel} + Newsletter`,
        {
          Source: this.sourceLabel,
          'Lead Magnet Opt-In': true,
          'Newsletter Opt-In': true
        }
      );
    }

    showError(message) {
      if (this.successEl) {
        this.successEl.hidden = true;
      }
      if (!this.errorEl) return;
      this.errorEl.textContent = message || 'Something went wrong. Please try again.';
      this.errorEl.hidden = false;
      this.errorEl.focus();
    }

    showSuccess() {
      if (this.errorEl) {
        this.errorEl.hidden = true;
        this.errorEl.textContent = '';
      }
      if (this.successTextEl && !this.successTextEl.textContent.trim() && this.successDefault) {
        this.successTextEl.textContent = this.successDefault;
      }
      if (this.successEl) {
        this.successEl.hidden = false;
        this.successEl.focus();
      }
      if (this.submitButton) this.submitButton.disabled = true;
      if (this.emailInput) this.emailInput.setAttribute('readonly', 'readonly');
      if (this.newsletterCheckbox) this.newsletterCheckbox.disabled = true;
    }

    async handleSubmit() {
      if (this.isSubmitting || !this.emailInput) return;

      const email = this.emailInput.value.trim();
      if (!email) {
        this.emailInput.focus();
        this.showError('Please enter your email address.');
        return;
      }
      if (typeof this.emailInput.checkValidity === 'function' && !this.emailInput.checkValidity()) {
        this.emailInput.focus();
        this.showError(this.emailInput.validationMessage || 'Please enter a valid email address.');
        return;
      }

      this.isSubmitting = true;
      this.setTags();
      this.trackKlaviyo();

      if (this.submitButton) {
        this.submitButton.disabled = true;
        this.submitButton.setAttribute('aria-busy', 'true');
      }

      if (this.errorEl) {
        this.errorEl.hidden = true;
        this.errorEl.textContent = '';
      }

      // 1) Critical for PDF: always subscribe to the lead magnet list
      let listSubscribed = false;
      try {
        listSubscribed = await this.subscribeToLeadMagnetList(email);
      } catch (error) {
        console.error('Klaviyo lead magnet subscribe error', error);
      }

      // 2) Newsletter checkbox: also subscribe to the newsletter list
      if (this.isNewsletterOptIn()) {
        try {
          await this.subscribeToNewsletterList(email);
        } catch (error) {
          console.error('Klaviyo newsletter subscribe error', error);
        }
      }

      // 3) Best-effort Shopify customer create (use /contact — form action — not pathname,
      //    which drops ?view=dev-page and 404s on alternate templates)
      const formData = new FormData(this.form);
      const shopifyEndpoint = (this.form.getAttribute('action') || '/contact').split('#')[0] || '/contact';
      try {
        await fetch(shopifyEndpoint, {
          method: 'POST',
          body: formData,
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json, text/javascript, */*;q=0.01',
            'X-Requested-With': 'XMLHttpRequest'
          },
          redirect: 'manual'
        });
      } catch (error) {
        // Ignore Shopify redirect/network quirks — PDF delivery depends on Klaviyo list.
      }

      if (listSubscribed) {
        this.showSuccess();
        return;
      }

      this.isSubmitting = false;
      this.showError('Something went wrong sending your link. Please try again.');
      if (this.submitButton) {
        this.submitButton.disabled = false;
        this.submitButton.removeAttribute('aria-busy');
      }
    }
  }

  if (!customElements.get('lead-magnet-form')) {
    customElements.define('lead-magnet-form', LeadMagnetForm);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
